import React from 'react';
import { Router } from 'react-router-dom';
import browserHistory from '@/config/browserHistory';
import './global.less';
import routes from '@/config/routerConfig';
import RouteList from '@/layouts/Routes/RouteList';

function App() {
  return (
    <Router history={browserHistory}>
      <RouteList routeConfig={routes} />
    </Router>
  );
}


export default App;
